export default "__VITE_ASSET__ac8d8f72__"